import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateService } from '../services/state.service';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { GoogleMapService } from '../services/google-map.service';
import { VehicleService } from '../services/vehicle.service';
import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-shared-map',
  templateUrl: './shared-map.component.html',
  styleUrls: ['./shared-map.component.css']
})
export class SharedMapComponent implements OnInit, OnDestroy {

  map:any = {};
  markers = [];
  infoContent = '';
  vehicles:any = [];
  openedInfoWdws = [];
  vehicleSubs:any;
  showPois = false;
  showZones = false;
  showControls = true;
  hash = "";
  username:any = "";
  unitId:any;
  selectedVehicle:any = {};
  isLoggedIn = false;
  currentGeoLoc = "";
  
  poisList:any = [];
  zonesList:any = [];
  
  zoom = 12;
  center = {
		lat: 3.129958,
		lng: 101.67509
	};

  infoWindow:any;
  marker:any;
  iconbase:any;
  infoWindowShown = false;
  bounds:any;
  toggleInfoWdw = false;
  hasCalled = false;
  pollInterval:any = false;
  datetm:any;
  source = "oncore";

  constructor(private stateSvc: StateService, private gmapSvc: GoogleMapService, private vehicleSvc: VehicleService,
    private activatedRoute: ActivatedRoute, private apiSvc: ApiService, private authSvc: AuthService
  ) {
    this.activatedRoute.params.subscribe((res)=>{
      this.hash = res['hash'];
      this.unitId = decodeURIComponent(atob(this.hash));
      this.username = decodeURIComponent(atob(res['user']));
      this.datetm = decodeURIComponent(atob(res['datetm']));

      // Get current datetime
      let now = new Date();
      let expiry = new Date(this.datetm);
      
      if(now > expiry){
        alert('Link has expired')
      }else{
        this.vehicleSvc.getVehicles(this.username).subscribe((vhc) => {
          this.source = "oncore";
          this.filteredUrl();
        },(err) => {
          this.source = "bsj";
          this.filteredUrl();
        });
      }
    })
  }

  filteredUrl(){
    if(this.source == 'bsj'){
      this.authSvc.getCredentialData()
      .subscribe((str:any) => {
        this.authSvc.getOutUsers(this.username, str?.collection_keys?.master, str?.collection_keys?.base_url)
        .subscribe((user:any) => {
          if(user?.username){
            // stote user local
            this.vehicleSvc.getUsersVehicles(user?.id)
            .subscribe((uvhcls:any) => {
              if(uvhcls?.length > 0){
                let dataUvhsc:any = [];
                uvhcls.forEach((uvhc:any) => {
                  dataUvhsc.push(uvhc.terminalNo);
                })
                this.stateSvc.setUsersVehicleIds(dataUvhsc);
              }
              this.startPolling();
            });
          }
        })
      })
    }else{
      this.startPolling();
    }
    
  }

  startPolling(){
    this.stateSvc.isLoggedIn.subscribe((result:boolean) => {
      this.isLoggedIn = result;
      if(!this.isLoggedIn && !this.hasCalled){
        // if already logged in, fetch vehicles
        this.callVehicleApi();
        // create interval to fetch vehicles
        this.pollInterval = setInterval(() => {
          this.callVehicleApi();
        }, 30 * 1000);
        this.hasCalled = true;
      }
    });
    this.afterVhclFound();
  }

  ngOnInit(): void {
    this.iconbase = this.apiSvc.getIconbase();
    this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
      zoom: this.zoom,
      center: this.center
    });
  }

  afterVhclFound(){
    this.vehicleSubs = this.stateSvc.vehicles
    .subscribe((result) => {
      let vhcls = result;
      this.vehicles = vhcls;console.log('this.unitId',this.unitId)
      this.vehicles?.forEach((vhcl) => {
        if(vhcl.unitid == this.unitId){
          this.selectedVehicle = vhcl;
          this.currentGeoLoc = vhcl.location;
          vhcl.geolocation = "";
          this.vehicleSvc.reverseGeocode(vhcl.lat, vhcl.lon)
            .subscribe((res) => {
              if(res && res != ""){
                vhcl.geolocation = res;
                var strHtml = this.writeInfoContent(vhcl, othersAttr);
                vhcl.infoWindow = new google.maps.InfoWindow({
                  content: strHtml //vhcl.infowWindowContent
                });
              }
            })
          let symbol = vhcl.symboltype + 1;
					if (symbol < 10) {
						symbol = '0' + symbol;
					}
          if(this.marker){
            this.marker.setMap(null);
          }
					this.marker = new google.maps.Marker({
						position: vhcl.markerPosition,
						icon: this.iconbase + symbol + '.png'
					});
          this.marker.setMap(this.map);
          
          let othersAttr = (parseFloat(vhcl.trailerid)).toFixed(2);
          if(vhcl.trailerid == "" && vhcl.battery && (vhcl.battery).indexOf('|') > -1){
            let strBatt = (vhcl.battery).split('|');
            if(strBatt[8]){
              vhcl.batteryPercent = strBatt[8] + "%";
              othersAttr = vhcl.batteryPercent;
            }
          }
                    
          this.map.setCenter(vhcl.markerPosition);
          
          if(this.infoWindowShown){
            vhcl.infoWindow.open(this.map, this.marker);
            this.infoWindowShown = true;
            this.toggleInfoWdw = true;
          }
					// this.infoWindowShown = false;
					this.marker.addListener('click', () => {
            vhcl.infowWindowContent = this.writeInfoContent(vhcl, vhcl.othersAttribute);
            vhcl.infoWindow.setContent(vhcl.infowWindowContent);
						if (!this.infoWindowShown) {
							vhcl.infoWindow.open(this.marker?.map, this.marker);
							this.infoWindowShown = true;
							this.toggleInfoWdw = true;
						} else {
							vhcl.infoWindow.close();
							this.infoWindowShown = false;
							this.toggleInfoWdw = false;
						}
					});
					google.maps.event.addListener(vhcl.infoWindow,'closeclick',() => {
						this.infoWindowShown = false;
						this.toggleInfoWdw = false;
					});
          return;
        }
      });
    });
  }

  ngOnDestroy(){
	  this.vehicleSubs.unsubscribe();
    this.map = null;
    clearInterval(this.pollInterval);
    this.pollInterval = false;
  }
  
  poiToggle(){
    this.showPois = !this.showPois;
    this.drawPois();
  }
  
  zonesToggle(){
    this.showZones = !this.showZones;
    this.drawZones();
  }
  
  resetZoom(){
    let hadShownVehicle = false;
    if(this.map?.mapTypeId && hadShownVehicle){
      
    }else if(!hadShownVehicle){
      this.map.setZoom(this.zoom);
    }
  }
  
  toggleShowControl(){
    this.showControls = !this.showControls; 
    this.stateSvc.setShowControl(this.showControls);
  }
  
  drawPois(){
    let zoom = this.map.getZoom();
    if (zoom >= 14 && this.showPois) {
      this.poisList.forEach((poi) => {
        !poi.getMap() && poi.setMap(this.map);
      });
    } else {
      this.poisList.forEach((poi) => {
        poi.getMap() && poi.setMap();
      });
    }
  }
  
  drawZones(){
    let zoom = this.map.getZoom();
    if (zoom >= 14 && this.showZones) {
      this.zonesList.forEach((zone) => {
        !zone.getMap() && zone.setMap(this.map);
      });
    }else {
      this.zonesList.forEach((zone) => {
        zone.getMap() && zone.setMap();
      });
    }
  }

  callVehicleApi(){
    if(this.source == "oncore"){
			this.vehicleSvc.getVehicles(this.username).subscribe((vhc) => {
        
      });
		}else{console.log('err', this.source)
      this.vehicleSvc.getVehicleOuts().subscribe((vhc) => {

      });
    }
		
	}

  writeInfoContent(vhcl, othersAttr){
    let fieldDisplays = this.stateSvc.getMapFieldIds();
    let str = '<div style="width:300px;padding:10px;"><div class="vehicle--summary-header '+vhcl.unitid+'">'+
          '<span class="vehicle--plate" style="width:100%;float:left;"><strong>' + vhcl.description + '</strong></span>'+
          '</div>' +
          '<div style="margin-bottom:10px;width:100%"><small class="text-muted">' + vhcl.convertedTime + '</small></div>' +
          '<div style="width:100%;overflow:hidden;font-size:15px;">';
			fieldDisplays.forEach((fld) => {
				str += '<div style="width:'+fld.width+'%;float:left;padding-right:5px;">';
				if(fld.value){
					if(fld.col == 'coordinate'){
						let urlEnc = encodeURIComponent(vhcl.geolocation);
						let mapStr = "https://www.google.com/maps?q="+vhcl.lat+","+vhcl.lon;
						str += '<p class="mdb-5" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-'+ fld.icon +'" title="'+fld.name+'" aria-hidden="true"></i>&nbsp;&nbsp;:</strong><a href="'+mapStr+'" target="_blank" style="outline: none;"> ' + (vhcl[fld.col]? vhcl[fld.col] : '-') + '</a></p>';
					}else{
						str += '<p class="mdb-5" style="margin-bottom:8px;"><strong><i style="font-size:15px;" class="fa fa-'+ fld.icon +'" title="'+fld.name+'" aria-hidden="true"></i>&nbsp;&nbsp;:</strong> ' + (vhcl[fld.col]? vhcl[fld.col] : '-') + '</p>';
					}
				}
				str += '</div>';
			});
			str += '</div>'+
          '</div>';

		return str;
  }

}
